<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Receipt Settings' }}</h2>
      <p>The issuer block (name, address, GSTIN, logo) printed on every payment receipt.</p>
    </div>
    <p-button label="Add Setting" icon="pi pi-plus" (onClick)="openAdd()" />
  </div>

  <div class="card">
    <div class="toolbar">
      <div class="filter">
        <label>Client</label>
        <p-select
          [ngModel]="filterClientId()"
          (ngModelChange)="onFilterChange($event)"
          [options]="clientOptions()"
          optionValue="value"
          optionLabel="label"
          [showClear]="true"
          [filter]="true"
          placeholder="All clients"
          appendTo="body"
          styleClass="filter-select" />
      </div>
      <span class="count">{{ visible().length }} of {{ rows().length }}</span>
    </div>

    <p-table [value]="visible()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="visible().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 210px">Scope</th>
          <th>Issuer</th>
          <th>GSTIN</th>
          <th style="width: 110px">Active</th>
          <th class="ta-r" style="width: 140px">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td>
            @if (r.clientId == null) {
              <p-tag value="Main / Partner" severity="info" />
            } @else {
              <span class="client-scope">
                <p-tag [value]="'Client'" severity="secondary" />
                <span class="client-name">{{ r.clientName || clientLabel(r.clientId) }}</span>
              </span>
            }
          </td>
          <td>
            <div class="issuer">
              @if (logoSrc(r)) {
                <img class="issuer-logo" [src]="logoSrc(r)" alt="" />
              }
              <div class="issuer-text">
                <span class="issuer-name">{{ r.issuerName }}</span>
                @if (r.issuerEmail || r.issuerPhone) {
                  <small class="issuer-sub">
                    {{ r.issuerEmail }}{{ r.issuerEmail && r.issuerPhone ? ' · ' : '' }}{{ r.issuerPhone }}
                  </small>
                }
              </div>
            </div>
          </td>
          <td>
            @if (r.issuerGstin) { <span class="mono">{{ r.issuerGstin }}</span> } @else { <span class="dash">—</span> }
          </td>
          <td>
            <span class="active-toggle" (click)="toggleActive(r)" pTooltip="Click to toggle">
              <p-tag [value]="r.isActive ? 'Active' : 'Inactive'"
                [severity]="r.isActive ? 'success' : 'secondary'" />
            </span>
          </td>
          <td class="ta-r actions">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Edit" (onClick)="openEdit(r)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
              pTooltip="Delete" (onClick)="remove(r)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="state">
              <i class="pi pi-receipt"></i>
              @if (filterClientId() != null) {
                <p>No receipt settings apply to this client yet.</p>
              } @else {
                <p>No receipt settings yet. Add the <strong>Main / Partner</strong> issuer to get started.</p>
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Receipt Setting' : 'New Receipt Setting'" styleClass="menu-dialog"
  [style]="{ width: '620px' }" [breakpoints]="{ '620px': '94vw' }">
  <form [formGroup]="form" class="menu-form">
    <div class="field">
      <label>Scope</label>
      <p-select [ngModel]="scopeMode()" (ngModelChange)="onScopeChange($event)"
        [ngModelOptions]="{ standalone: true }" [options]="scopeOptions" optionValue="value"
        optionLabel="label" appendTo="body" />
      <small class="hint-muted">
        Main / Partner is the default used by the main API and as a fallback for every client.
      </small>
    </div>

    @if (scopeMode() === 'CLIENT') {
      <div class="field">
        <label>Client <span class="req">*</span></label>
        <p-select formControlName="clientId" [options]="clientOptions()" optionValue="value"
          optionLabel="label" [filter]="true" placeholder="Select a client" appendTo="body" />
        <small class="hint-muted">Used by the Client microservice when printing this client's receipts.</small>
      </div>
    }

    <div class="field">
      <label>Issuer Name <span class="req">*</span></label>
      <input pInputText type="text" formControlName="issuerName" placeholder="Arogya Insurance" autocomplete="off">
      @if (form.get('issuerName')?.touched && form.get('issuerName')?.invalid) {
        <small class="err">Issuer name is required</small>
      }
    </div>

    <div class="field">
      <label>Issuer Address</label>
      <textarea pTextarea formControlName="issuerAddress" rows="2"
        placeholder="Street, city, state, pincode"></textarea>
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Email</label>
        <input pInputText type="text" formControlName="issuerEmail" placeholder="care@example.com" autocomplete="off">
      </div>
      <div class="field">
        <label>Phone</label>
        <input pInputText type="text" formControlName="issuerPhone" placeholder="+91 …" autocomplete="off">
      </div>
    </div>

    <div class="field">
      <label>GSTIN</label>
      <input pInputText type="text" formControlName="issuerGstin" placeholder="27ABCDE1234F1Z5" autocomplete="off">
    </div>

    <div class="field">
      <label>Logo</label>
      <app-doc-upload formControlName="logoUrl" module="ReceiptLogo" />
      <small class="hint-muted">
        Upload an image (JPG/PNG) — it uploads immediately and the file id is saved with this row.
        When set, the receipt header shows the logo instead of the name.
      </small>
    </div>

    @if (logoPreview()) {
      <div class="logo-preview">
        <span class="preview-label">Logo preview</span>
        <p-image [src]="logoPreview()" alt="Logo preview" [preview]="true" width="120" />
      </div>
    }

    <label class="switch-row">
      <p-toggleSwitch formControlName="isActive" />
      <span>Active</span>
    </label>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
      <p-button label="Save" (onClick)="save()" [loading]="saving()" />
    </div>
  </form>
</p-dialog>
